import { TOGGLE_BUTTONS_ARRAY_BUTTON, SET_IS_SCROLLED } from './constants'

export function toggleButtonsArrayButton(moduleName, arrayName, name) {
    return {
        type: TOGGLE_BUTTONS_ARRAY_BUTTON,
        data: {
            moduleName,
            arrayName,
            name,
        },
    }
}

export function setIsScrolled(data) {
    return {
        type: SET_IS_SCROLLED,
        data,
    }
}
